// AUTO-GENERATED SQL Builder (V40 Final) for AdvanceTier
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class AdvanceTierSql {
  private ast = new SqlAst('AdvanceTier', 'advanceTier');
  public readonly main: any = {};

  public guid: SqlField;
  public name: SqlField;
  public minCompletedBookings: SqlField;
  public minCompletedVolume: SqlField;
  public maxAdvancePercent: SqlField;
  public maxAdvanceAmount: SqlField;
  public rollingLimit: SqlField;
  public sortOrder: SqlField;
  public status: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('advanceTier', 'guid', '', 'id', 'advanceTier_guid');
    this.name = new SqlField('advanceTier', 'name', '', 'id', 'advanceTier_name');
    this.minCompletedBookings = new SqlField('advanceTier', 'minCompletedBookings', '', 'id', 'advanceTier_minCompletedBookings');
    this.minCompletedVolume = new SqlField('advanceTier', 'minCompletedVolume', '', 'id', 'advanceTier_minCompletedVolume');
    this.maxAdvancePercent = new SqlField('advanceTier', 'maxAdvancePercent', '', 'id', 'advanceTier_maxAdvancePercent');
    this.maxAdvanceAmount = new SqlField('advanceTier', 'maxAdvanceAmount', '', 'id', 'advanceTier_maxAdvanceAmount');
    this.rollingLimit = new SqlField('advanceTier', 'rollingLimit', '', 'id', 'advanceTier_rollingLimit');
    this.sortOrder = new SqlField('advanceTier', 'sortOrder', '', 'id', 'advanceTier_sortOrder');
    this.status = new SqlField('advanceTier', 'status', '', 'id', 'advanceTier_status');
    this.createdByUser = createNavHybrid('advanceTier', 'advanceTier_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('advanceTier', 'advanceTier_updatedByUser', 'User');
    this.id = new SqlField('advanceTier', 'id', '', 'id', 'advanceTier_id');
    this.isDeleted = new SqlField('advanceTier', 'isDeleted', '', 'id', 'advanceTier_isDeleted');
    this.createdBy = new SqlField('advanceTier', 'createdBy', '', 'id', 'advanceTier_createdBy');
    this.createdDate = new SqlField('advanceTier', 'createdDate', '', 'id', 'advanceTier_createdDate');
    this.updatedBy = new SqlField('advanceTier', 'updatedBy', '', 'id', 'advanceTier_updatedBy');
    this.updatedDate = new SqlField('advanceTier', 'updatedDate', '', 'id', 'advanceTier_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:AdvanceTierSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:AdvanceTierSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:AdvanceTierSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:AdvanceTierSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:AdvanceTierSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:AdvanceTierSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:AdvanceTierSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:AdvanceTierSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:AdvanceTierSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:AdvanceTierSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
